export const ListServicesOptions = [
    { value: "pickup", label: "Pickup" },
    { value: "delivery", label: "Delivery" },
    { value: "dine_in", label: "Dine In" },
    { value: "table_booking", label: "Table Booking" },
];
export const ListServicesOptionsNoB = [
    { value: "pickup", label: "Pickup" },
    { value: "delivery", label: "Delivery" },
    { value: "dine_in", label: "Dine In" },
];
export const ListPaymentsOptions = [
    { value: "cash", label: "Cash" },
    { value: "card", label: "Card" },
    { value: "stripe", label: "Stripe" },
    { value: "paypal", label: "PayPal" },
    { value: "cardconnect", label: "CardConnect" },
    { value: "paygate_payweb", label: "Paygate Payweb" },
    { value: "poli_pay", label: "POLi Pay" },
    { value: "ipay88", label: "IPay 88" },
    { value: "bambora_apac", label: "Bambora APAC" },
    { value: "bambora_na", label: "Bambora North America" },
    { value: "pesapal", label: "Pesapal" },
    { value: "ath_movil", label: "ATH Móvil" },
    { value: "checkout", label: "Checkout" },
    { value: "checkout_apple_pay", label: "Apple Pay (Checkout.com)" },
    { value: "checkout_google_pay", label: "Google Pay (Checkout.com)" },
    {
        value: "stripe_digital_wallet",
        label: "Stripe Digital Wallet (Google Pay, Apple Pay)",
    },
    { value: "razor_pay", label: "Razor Pay" },
    { value: "authorized", label: "Authorize.net" },
    { value: "gravity", label: "Gravity" },
    { value: "elavon", label: "Elavon" },
    { value: "red_dot", label: "Red Dot Payment" },
    { value: "gkash", label: "Gkash" },
    { value: "sgepay", label: "SGEPAY" },
    { value: "payway", label: "ABA Pay" },
];
export const ListPaymentLogosOptions = [
    { value: "mastercard", label: "Mastercard" },
    { value: "paygate", label: "Paygate" },
    { value: "payway", label: "ABA Pay" },
    { value: "paypal", label: "PayPal" },
    { value: "poli", label: "POLi Pay" },
    { value: "stripe-dark", label: "Stripe (Dark)" },
    { value: "stripe-light", label: "Stripe (Light)" },
    { value: "visa", label: "Visa" },
];
export const ListOrderTimesOptions = [
    { value: "now", label: "Now" },
    { value: "later", label: "Later" },
];
//# sourceMappingURL=restaurant.js.map